import React from 'react';
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TableSortLabel,
  TableContainer,
  IconButton,
  Checkbox, FormControlLabel
} from '@material-ui/core';
import PlaylistAddIcon from '@material-ui/icons/PlaylistAdd';
import { useStyles, StyledTableCell } from '../../adminStyles';

const SummaryTable = props => {
  const {
    sortLabel,
    tableRoot,
    tableContainer,
    tableHeaders,
    customHeaderCont,
    disabledIcons,icons
  } = useStyles();

  const {
    columns,
    rows,
    sortArray,
    selectAll,
    selectByIndex,
    orderAscending,
    handleDetailOpen,
    orderBy,
    asc,
    searchTerm,
    employeeType,allRecord
  } = props;
  const renderTableHeader = () =>
    columns.map((column, index) =>
        column.id === 'managerName'||
        column.id === 'milestoneId'||
        column.id === 'userName'||
        column.id === 'details' ||
        column.id === 'regularHrs' ||
        column.id === 'holidayHrs' ||
        column.id === 'vacationHrs' ||
        column.id === 'sickHrs' ||
        column.id === 'bereavementHrs' ||
        column.id === 'totalHrs' ? (
          <StyledTableCell
            key={column.id}
            align='center'
            sortDirection={orderBy === column.id ? orderAscending : false}
          >
            <TableSortLabel
              active={orderBy === column.id}
              direction={asc}
              onClick={sortArray(rows, column.id)}
              className={sortLabel}
            >
              {column.label}
            </TableSortLabel>
          </StyledTableCell>
        ) : (
          <StyledTableCell key={column.id} align='center'>
            <FormControlLabel
              control={<Checkbox name="checkedA" checked={allRecord} onClick={(e)=>{selectAll(rows,e)}}/>}
              label="All" />
          </StyledTableCell>
        )
        
    );

  const renderTableBody = () =>
    rows      
      .map((row, i) => {
        return (
          <TableRow tabIndex={-1} key={row.code}>
            {columns.map(column => {
              const value = row[column.id];

              return (
                <TableCell key={column.id} align='center'> 
                  {column.id === 'managerName'? value:null}
                  {column.id === 'milestoneId'? value:null}
                  {column.id === 'userName' ? value : null}
                  {column.id === 'regularHrs' ? value : null}
                  {column.id === 'holidayHrs' ? value : null}
                  {column.id === 'vacationHrs' ? value : null}
                  {column.id === 'sickHrs' ? value : null}
                  {column.id === 'bereavementHrs' ? value : null}
                  {column.id === 'totalHrs' ? value : null}
                  {column.id === 'details' ? (
                    <IconButton disabled={!row.details.length}  onClick={() => handleDetailOpen(row[column.id],row.userName)}>
                      <PlaylistAddIcon
                        className={row.details.length ? icons : disabledIcons}
                      />
                    </IconButton>
                  ) : null}
                </TableCell>
              );
            })}
          </TableRow>
        );
      });

  const renderTotalsHeader = () => {
    return (
      <div className={customHeaderCont}>
        <div className={tableHeaders}>
          Regular Hrs Total:
          <span style={{ color: '#42ADE2' }}>
            {rows.reduce((a, b) => a + (b['regularHrs'] || 0), 0)}
          </span>
        </div>
        <div className={tableHeaders}>
          Holiday Hrs Total:
          <span style={{ color: '#42ADE2' }}>
            {rows.reduce((a, b) => a + (b['holidayHrs'] || 0), 0)}
          </span>
        </div>
        <div className={tableHeaders}>
          Vacation Hrs Total:
          <span style={{ color: '#42ADE2' }}>
            {rows.reduce((a, b) => a + (b['vacationHrs'] || 0), 0)}
          </span>
        </div>
        <div className={tableHeaders}>
          Sick Hrs Total:
          <span style={{ color: '#42ADE2' }}>
            {rows.reduce((a, b) => a + (b['sickHrs'] || 0), 0)}
          </span>
        </div>
        <div className={tableHeaders}>
          Total Hrs Total:
          <span style={{ color: '#42ADE2' }}>
            {rows.reduce((a, b) => a + (b['totalHrs'] || 0), 0)}
          </span>
        </div>
      </div>
    );
  };

  return (
    <Paper className={tableRoot}>
      <TableContainer className={tableContainer}>
        <TableRow>{renderTotalsHeader()}</TableRow>
        <Table stickyHeader>
          <TableHead>
            <TableRow>{renderTableHeader()}</TableRow>
          </TableHead>
          <TableBody>{renderTableBody()}</TableBody>
        </Table>
      </TableContainer>
    </Paper>
  );
};

export default SummaryTable;
